module.exports = "https://web-assets.ifttt.com/packs/media/docs/metadata-b28ecbcd.png";